import { render } from "./Newsletter.vue?vue&type=template&id=0508ad1c&scoped=true"
import script from "../js/newsletter.js?vue&type=script&lang=js"
export * from "../js/newsletter.js?vue&type=script&lang=js"

import "./Newsletter.vue?vue&type=style&index=0&id=0508ad1c&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0508ad1c"]])

export default __exports__